export default {
    group: [],
    isLogged: false,
    permisos: [],
    sucursal: '',
    user: { username: '', full_name: '', groups: [], role: '' },
    nombreSucursal: '',
    uuidSucursal: '',
    empresa: null,
    suscripcion: { plan: null, vigente: false, modulos: [], servicios: [], features: [] },
}
